<template>
  <ControlCommonLayout header="controlHeader" footer="controlFooter">
    <div class="container">
      <div class="main-color text-light row mt-3">
        <div class="col p-2">
          商品画像登録
        </div>
      </div>
      <form method="post" action="#" class="form-horizontal">
        <b-overlay :show="overlayShow" rounded="sm">
          <div class="row base-color">

            <div class="col-sm-12 row p-3">
              <div class="col-sm-6">
                商品画像をセットし、登録してください。
              </div>
            </div>
            <div class="col-sm-12">
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td class="p-1 light-blue">商品コード</td>
                    <td class="p-1">{{getPlanItem('商品コード')}}</td>
                    <td class="p-1 light-blue">商品名</td>
                    <td class="p-1">{{getPlanItem('商品名')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">大区分</td>
                    <td class="p-1">{{getPlanItem('大区分')}}</td>
                    <td class="p-1 light-blue">商品単価</td>
                    <td class="p-1">{{getPlanItem('商品単価')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">中区分</td>
                    <td class="p-1">{{getPlanItem('中区分')}}</td>
                    <td class="p-1 light-blue">色</td>
                    <td class="p-1">{{getPlanItem('色商品')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">小区分</td>
                    <td class="p-1">{{getPlanItem('小区分')}}</td>
                    <td class="p-1 light-blue">季節</td>
                    <td class="p-1">{{getPlanItem('季節')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">施設コード</td>
                    <td class="p-1">{{getPlanItem('施設コード')}}</td>
                    <td class="p-1 light-blue">メーカー</td>
                    <td class="p-1">{{getPlanItem('商品メーカー')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">施設名</td>
                    <td class="p-1">{{getPlanItem('施設名')}}</td>
                    <td class="p-1 light-blue">形態</td>
                    <td class="p-1">{{getPlanItem('形態')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">商品登録担当者</td>
                    <td class="p-1">{{getPlanItem('作成者')}}</td>
                    <td class="p-1 light-blue">商品登録日時</td>
                    <td class="p-1">{{changeDateFormat(getPlanItem('作成日時'))}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-sm-12 m-auto row pt-4">
              <div class="col-sm-6">
                <!-- 代表画像 -->
                <div class="card">
                  <div class="" v-if="images[6] !== null">
                    <img id="image-6" class="card-img-top main-img w-100 h-100" :src="images[6]">
                  </div>
                  <div class="" v-else>
                    <div class="tile-image-dev text-center pt-4">
                      <b-icon icon="image" font-scale="2"></b-icon>
                      <p>no Image</p>
                    </div>
                  </div>
                  <div class="card-body pb-2">
                    <p class="card-title">代表画像</p>
                    <div class="row" v-if="toroku">
                      <div class="col" v-show="images[6] !== null">
                        <button type="button" class="btn pl-0">
                          <b-icon class="text-primary" icon="arrow-clockwise" @click="clickRotate()"></b-icon>
                        </button>
                      </div>
                      <div class="text-right text-primary col text-nowrap pt-2">
                        <a class="text-primary" v-if="images[6] === null" @click="uploadImage(6)">画像を登録</a>
                        <a class="text-primary" v-else @click="clickClear()">画像クリア</a>
                      </div>
                      <input id="image-file-input-6" class="d-none" type="file" @change="registImage">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6" style="color: red;font-size: small;" v-if="toroku">
                <td>注意：リサイズしてアップロードください。上限3MB（推奨1MB未満）</td>
            </div>
          </div>
        </b-overlay>
      </form>
    </div>
    <CommonModal ref="commonModal" />
    <CommonModal ref="commonModalRotate" @confirmOk="rotateImage(6)" />
    <CommonModal ref="commonModalClear" @confirmOk="clearImage(6)" />
  </ControlCommonLayout>
</template>
<script>
import ControlCommonLayout from '@/layout/ControlCommonLayout'
import CommonModal from '@/components/CommonModal'
import PlanImageModel from '@/models/PlanImageModel'

export default {
  name: 'ControlItemImageRegistration',
  components: { ControlCommonLayout, CommonModal, PlanImageModel },
  data () {
    return {
      overlayShow: false,
      noImage: '/static/NoImage.png',
      images: {},
      resizeImages: [],
      userId: '',
      toroku: false,
      routeItemCode: ''
    }
  },
  methods: {
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      console.log(this.$route.meta)
      console.log(this.$route.query)
      this.userId = this.$route.meta.userId
      this.toroku = (this.$route.meta.toroku === 'true')

      const reqData = {
        'itemCode': this.routeItemCode
      }
      const result = await PlanImageModel.getApi(this.$bvModal, reqData, () => {})
      console.log(result)
      if (result === undefined) {
        console.log('PlanImageModel:undefined')
      } else if (result && result.status === 403) {
        console.log('PlanImageModel:403')
      }
      this.getPlanImage()
      this.overlayShow = false
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    changeDateFormat (date) {
      if (date === null) {
        return null
      }

      date = date.replace('T', ' ').replace('Z', ' ').replace('-', '/').replace('-', '/')
      return date
    },
    getPlanItem (key) {
      const store = PlanImageModel.getStore()
      if (!store || store['items'] === null || !(key in store['items']) || !store['items'][key]['value']) {
        return null
      }
      let rtn = store['items'][key]['value']
      if (key === '作成者' || key === '更新者') {
        rtn = rtn['name']
      }
      return rtn
    },
    resizeImage (imageData, num, canvasWidth, canvasHeight) {
      const canvas = document.createElement('canvas')
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(imageData, 0, 0, canvasWidth, canvasHeight)

      this.resizeImages[num] = canvas.toDataURL('image/jpeg').replace(/^.*,/, '')

      canvas.height = 0
      canvas.width = 0
      canvas.remove()
      this.$delete(canvas)
    },
    beforeResizeImage (file, self, i) {
      const image = new Image()
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        image.src = reader.result
        image.onload = (e) => {
          let canvasWidth = 0
          let canvasHeight = 0
          // 横幅と高さのいずれかが1280pxを超えている場合はリサイズ
          if (image.naturalWidth > 1280 || image.naturalHeight > 1280) {
            // アスペクト比計算
            const w = image.naturalWidth
            const h = image.naturalHeight
            const g = self.gcd(w, h)
            const ratioW = w / g
            const ratioH = h / g
            if (ratioW > ratioH) {
              // 横長画像(横幅 > 高さ)の場合
              canvasWidth = 1280
              canvasHeight = (1280 / ratioW) * ratioH
            } else {
              // 縦長画像(横幅 < 高さ)の場合
              canvasHeight = 1280
              canvasWidth = (1280 / ratioH) * ratioW
            }
          } else {
            canvasWidth = image.naturalWidth
            canvasHeight = image.naturalHeight
          }
          self.resizeImage(image, i, canvasWidth, canvasHeight)
        }
      }
    },
    getPlanImage () {
      // 画像情報の設定
      const store = PlanImageModel.getStore()
      if (!store || store['images'] === null) {
        this.$set(this.images, 6, null)
        return null
      }
      for (let i in store['images']) {
        // imageの数だけ繰り返す。1件しか使用しないが、app.pyに手を加えたくないためこれで行く。
        this.$set(this.images, store['images'][i]['displayOrderNumber'], store['images'][i]['imagePath'])
      }
      console.log(this.images)
    },
    uploadImage (displayOrderNumber) {
      // 画像のアップロード
      document.getElementById('image-file-input-' + displayOrderNumber).click()
    },
    registImage: async function (e) {
      // 画像の登録
      if (typeof e.target.files[0] === 'undefined') {
        return false // 失敗していたらfalseを返す
      }

      const displayOrderNumber = 6
      const file = e.target.files[0]

      const extend = file.name.match(/[^.]+$/)[0]
      if (['PNG', 'png', 'JPG', 'JPEG', 'jpg', 'jpeg', 'GIF', 'gif'].includes(extend) === false) {
        this.$refs.commonModal.msgBoxOk('アップロード可能なファイル形式はjpeg・jpg・png・gifのみです。')
        document.getElementById('image-file-input-6').value = ''
        return false
      }

      if (file.size > 3000000) {
        this.$refs.commonModal.msgBoxOk('ファイルサイズが3MBを超えているためアップロードできません。')
        document.getElementById('image-file-input-6').value = ''
        return false
      } else if (file.size > 1000000) {
        this.$refs.commonModal.msgBoxOk('ファイルサイズが1MBを超えております。縮小されていないファイルの可能性があります。')
      }

      this.overlayShow = true

      await this.beforeResizeImage(file, this, 6)
      let intervalflg = true
      const intervalId = setInterval(async () => {
        // resizeImagesに値がセットされたときに実行する
        if (intervalflg && this.resizeImages[displayOrderNumber]) {
          // 定期実行を終了
          clearInterval(intervalId)
          intervalflg = false

          if (this.resizeImages[displayOrderNumber].length > 4000000) {
            this.$refs.commonModal.msgBoxOk('アップロード可能なファイルサイズ上限は4MBです。')
            return false
          }

          let reqData = {
            'itemCode': this.routeItemCode,
            'userId': this.userId,
            'regist': [
              {
                'fileName': file.name,
                'displayOrderNumber': displayOrderNumber,
                'imageData': this.resizeImages[displayOrderNumber]
              }
            ],
            'delete': []
          }
          const result = await PlanImageModel.postApi(this.$bvModal, reqData, () => {})
          this.$set(this.images, displayOrderNumber, result['images']['imagePath'])
          this.overlayShow = false
          // 同名のファイルで再アップロードを可能とするために、アップロードファイルの情報を削除
          document.getElementById('image-file-input-6').value = ''
          this.resizeImages[displayOrderNumber] = ''
        }
      }, 300)
    },
    gcd (x, y) {
      if (y === 0) {
        return x
      }
      return this.gcd(y, x % y)
    },
    toDataUrl (file) {
      // ファイルのURL取得
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
      })
    },
    rotateImage: async function (displayOrderNumber) {
      // 画像回転
      this.overlayShow = true
      const reqData = {
        'itemCode': this.routeItemCode,
        'userId': this.userId,
        'displayOrderNumber': String(displayOrderNumber),
        'imagePath': document.getElementById('image-' + displayOrderNumber).src
      }
      // dynamoのデータ更新、s3に画像アップロード
      const result = await PlanImageModel.putApi(this.$bvModal, reqData, () => {})
      this.$set(this.images, displayOrderNumber, result['images']['imagePath'])
      this.overlayShow = false
    },
    clearImage: async function (displayOrderNumber) {
      // 画像削除
      this.overlayShow = true
      const reqData = {
        'itemCode': this.routeItemCode,
        'userId': this.userId,
        'displayOrderNumber': String(displayOrderNumber),
        'delete': document.getElementById('image-' + displayOrderNumber).src
      }
      // dynamoのデータ削除、s3の画像削除
      await PlanImageModel.deleteApi(this.$bvModal, reqData, () => {})
      this.$set(this.images, displayOrderNumber, null)
      this.overlayShow = false
    },
    clickRotate () {
      this.$refs.commonModalRotate.msgBoxConfirm(this.consts.messages.imageRotate)
    },
    clickClear () {
      this.$refs.commonModalClear.msgBoxConfirm(this.consts.messages.imageClear)
    }
  },
  mounted () {
    this.routeItemCode = this.$route.query.itemCode
    this.setApiData()
  }
}
</script>
<style>
.word-pre-wrap{
    white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/ControlItemImageRegistration.vue